import { render, staticRenderFns } from "./TopicCard.vue?vue&type=template&id=ea3e3b84&scoped=true"
import script from "./TopicCard.vue?vue&type=script&lang=js"
export * from "./TopicCard.vue?vue&type=script&lang=js"
import style0 from "./TopicCard.vue?vue&type=style&index=0&id=ea3e3b84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea3e3b84",
  null
  
)

export default component.exports